module.exports = __webpack_public_path__ + "static/digital_consulting-3d6140a3e3a1cf4282afe27a373c15a8.jpg";